import Button from "components/common/button/Button";
import Input from "components/common/form/inputs/Input";
import PageHeader from "components/common/page/PageHeader";
import { useState } from "react";
import { useContext } from "react";
import { getAppContext } from 'config/AppContext';
import Form from "components/common/form/Form";
import { IUser } from "types/user-type";
import { api } from "config/axios-context";

const ProfileFormPage = () => {
    const context = getAppContext(useContext);
    let [model, setModel] = useState({
        name: context.user.name,
        username: context.user.username
    });

    const onChange = (name: keyof typeof model, value?: string) => {
        const changeModel = { ...model };
        changeModel[name] = value || '';
        setModel(changeModel);
    }

    const onSubmit = async () => {
        try {
            var response = await api.post<IUser>('/auth/profile', model);
            if(response.success) {  
                (window.location as any) = '/profile';
            } else {
                context.notify('error', 'fuck');
            }
        } catch (error) {
            throw error;
        }
    };

    return (
        <div className="lg:px-5">
            <PageHeader title="pages.edit-profile" />
            <div className="w-full sm:w-max">
                <Form onSubmit={onSubmit} name="profile-form">
                    <fieldset>
                        <Input
                            name="name"
                            autofill="name"
                            value={model.name}
                            label="fields.name.name"
                            minLength={2}
                            autoFocus
                            maxLength={50}
                            required
                            touched
                            onChange={e => onChange('name', e)}
                        />
                        <Input
                            name="username"
                            autofill="username"
                            value={model.username}
                            label="fields.username.name"
                            onChange={e => onChange('username', e)}
                            pattern="[a-z]+[a-z0-9._]+"
                            minLength={4}
                            maxLength={50}
                            touched
                            required
                        />
                    </fieldset>
                    <fieldset className="form-actions">
                        <Button type="submit" title="button.submit" theme="primary">
                            <span>Submit</span>
                        </Button>
                        <Button type="submit" title="button.reset">
                            <span>Reset</span>
                        </Button>
                    </fieldset>
                </Form>
            </div>
        </div>
    );
};

export default ProfileFormPage;
